/// <amd-module name="Feed/Legacy/Helpers/PackageGridMessages" />
import { FeedCapabilities, Package } from "Feed/Common/Contracts/Feed";
import { MessageState } from "Feed/Common/Types/IFeedMessage";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";

export class PackageGridMessages {
    public static getMessageForFeed(feed: Feed, packages: Package[], filterText: string): MessageState {
        if (packages != null && packages.length > 0) {
            return MessageState.None;
        }

        if (filterText != null) {
            return MessageState.EmptyFilter;
        }

        // View selected
        if (feed && feed.view != null) {
            return MessageState.EmptyView;
        }

        // Upstream source set to cache
        if (feed && feed.upstreamEnabled === true && feed.upstreamSource != null && feed.upstreamSource.id != null) {
            if (feed.capabilities != FeedCapabilities.None) {
                // if we have any capabilities other than none, don't refer to a cache:
                return MessageState.EmptySource;
            } else {
                return MessageState.EmptyCache;
            }
        }

        if (feed && feed.deletedDate != null) {
            return MessageState.DeletedFeed;
        }

        return MessageState.EmptyFeed;
    }

    public static getMessageForRecyclebin(feed: Feed, packages: Package[], filterText: string): MessageState {
        if (packages != null && packages.length > 0) {
            return MessageState.None;
        }

        if (filterText != null) {
            return MessageState.EmptyFilter;
        }

        return MessageState.None;
    }
}
